module.exports = __webpack_public_path__ + "img/证书查询.a4768019.png";